<template>
  <div id="mercadolibre-list">
    <div v-if="$store.getters.profile.company.has_credit !== false">
      <div v-if="alreadyIntegrated">
        <div v-if="isLoadingMeli" class="shipping-preview">
          <!-- Loading shippings... -->
        </div>
        <div v-else>

          <modal-need-stores v-if="$frontConfig.stores && $frontConfig.stores.force" />

          <b-card>
            <h5 v-show="!noFlexData" v-translate>Useful information about your FLEX integration</h5>
            <h5 v-show="noFlexData" v-translate>Useful information about your integration</h5>
            <b-row>
              <b-col>
                <small style="text-transform: uppercase" v-translate>MercadoLibre User</small>
                <p class="mb-0">
                  <span style="text-transform: uppercase;">{{$store.getters.meliUser.nickname}}</span><br>
                  <small><em>({{$store.getters.meliUser.email}})</em></small>
                </p>
              </b-col>
              <b-col>
                <widget-cut-time />
              </b-col>
              <b-col v-if="!noFlexData && !restartMlIntegration">
                <small style="text-transform: uppercase" v-translate>Your enabled FLEX zones</small>
                <h3 class="mb-0">
                  {{meliZones.filter(x => x.area && x.selected).length}}/{{meliZones.filter(x => x.area && x.selected).length + meliZones.filter(x => x.area && !x.selected).length}}
                  <span id="tooltip-zones">
                    <span v-if="canEnableZones">
                      <font-awesome-icon icon="exclamation-triangle" class="text-warning" size="1x" />
                      <small><small><small><a href="#" @click.prevent v-b-modal.modalReviewMeliZones v-translate>Review FLEX zones</a></small></small></small>
                    </span>
                    <font-awesome-icon v-else icon="check" class="text-success" size="1x" />
                  </span>
                  <b-modal size="md" id="modalReviewMeliZones" ref="modalReviewMeliZones" hide-footer>
                    <div slot="modal-title" v-translate>FLEX Zones Management</div>
                    <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
                    <form @submit.prevent="doUpdateZones">
                      <p v-translate>Here you can enable the MercadoLibre FLEX zones in which we bring services and reach many more buyers!</p>
                      <p v-if="meliZones.filter(x => !x.area).length > 0"><small v-translate>We still don't work into the grayed zones but we are working hard to do it as soon as possible. You will see the notice here every time we add a new zone.</small></p>
                      <b-form-checkbox-group v-model="updateZones">
                        <b-row v-for="(zone, index) in meliZones" :key="index">
                          <b-col class="py-3" style="border-top: 1px solid #ccc">
                             <b-form-checkbox :value="zone.id" :disabled="!zone.area">
                              <h5 :class="!zone.area ? 'text-muted' : ''">{{zone.label}}</h5>
                            </b-form-checkbox>
                          </b-col>
                          <b-col class="text-right py-3" style="border-top: 1px solid #ccc">
                            <h5 :class="!zone.area ? 'text-muted' : ''">{{parseInt(zone.price.fraction + zone.price.cents) / 100 | currency($store.getters.profile.company.country_iso_code)}}</h5>
                          </b-col>
                        </b-row>
                      </b-form-checkbox-group>
                      <b-row>
                        <b-col class="pt-4 text-center" style="border-top: 1px solid #ccc">
                          <b-button variant="primary" type="submit" v-translate>
                            Update Zones
                          </b-button>
                        </b-col>
                      </b-row>
                    </form>
                  </b-modal>
                </h3>
                <b-tooltip target="tooltip-zones">
                  <span v-if="canEnableZones">
                    <translate>There are FLEX zones where we work but you have them disabled into MercadoLibre. You can review this and manage your enabled/disabled FLEX zones here.</translate>
                  </span>
                  <span v-else>
                    <translate>Kudos! You currently have enabled all the FLEX zones where we work! 😊</translate>
                  </span>
                </b-tooltip>
              </b-col>
              <b-col v-if="noFlexData || restartMlIntegration">
                <b-alert variant="info" :show="noFlexData && !restartMlIntegration">
                  <h4 class="m-0" v-translate>Your integration is OK but your MercadoLibre User does not have FLEX enabled.</h4>
                </b-alert>
                <b-alert variant="warning" :show="restartMlIntegration">
                  <h4 class="m-0" v-translate>Your integration is not OK 😞</h4>
                  <div v-show="isCompanyAdmin">
                    <h5 v-translate>You need to restart your MercadoLibre integration to be able to create shippings here.</h5>
                    <b-button variant="primary" :to="{name: 'company-integrations'}" v-translate>
                      Manage Integrations
                    </b-button>
                  </div>
                  <h5 v-show="!isCompanyAdmin" v-translate>You Company Administrator need to restart the MercadoLibre integration to be able to create shippings here.</h5>
                </b-alert>
              </b-col>
            </b-row>
            <b-row v-if="!noFlexData" class="mt-3">
              <b-col>
                <h5 v-translate>Optional Holidays</h5>
                <p v-translate>Here you have a direct access to set up the Optional Holidays you <strong>WILL NOT operate in MercadoLibre</strong>:</p>
                <p><b-button variant="primary" size="sm" :href="'https://www.mercadolibre' + $frontConfig.domain +'/preferencias-de-venta/dias-festivos-opcionales'" target="_blank" v-translate>Set up Optional Holidays</b-button></p>
              </b-col>
            </b-row>
          </b-card>

          <b-card v-if="!noFlexData">
            <h4 v-translate>Automatic FLEX Shipping Creation</h4>
            <p v-translate>This tool will create all the FLEX shippings from your integrated MercadoLibre account automatically every 30 minutes. You only need to select the store for shippings' origin before being able to enable the automatic creation. That's all. Do it and relax!</p>
            <b-row>
              <b-col>
                <span id="tooltip-meli-automatic" class="d-inline-block w-10">
                <b-form-checkbox class="save-from my-1 w-auto"
                  v-model="meliAutomatic.automatic"
                  :value="true"
                  :unchecked-value="false"
                  plain
                  :disabled="!meliAutomatic.from_place_id"
                >
                  <span v-translate translate-context="female">Disabled</span> <span class="switch monochrome" :class="!meliAutomatic.automatic ? 'disabled' : ''"><span class="slider round"></span></span> <span v-translate translate-context="female">Enabled</span>
                </b-form-checkbox>
                </span>
                <b-tooltip target="tooltip-meli-automatic">
                  <span v-if="!meliAutomatic.from_place_id">
                    <translate>You must select the store for shippings' origin before being able to enable the automatic creation</translate>
                  </span>
                  <span v-else-if="meliAutomatic.from_place_id && !meliAutomatic.automatic">
                    <translate>You have selected the store for shippings' origin and you can enable the automatic creation anytime from now 😊</translate>
                  </span>
                  <span v-else>
                    <translate>Yay! The automatic shipping creation is now ON 😃</translate>
                  </span>
                </b-tooltip>
              </b-col>
              <b-col>
                <label for="from_extra" v-translate>Select a Shop</label>
                <b-form-select v-model="meliAutomatic.reference" :options="stores.map(x => { return { text: x.reference, value: x.reference } })" class="w-auto">
                  <template slot="first">
                    <option :value="null" v-translate>Select a Shop</option>
                  </template>
                </b-form-select>
              </b-col>
            </b-row>
          </b-card>

          <b-card class="bg-dargk tegxt-light" v-if="type !== 'search'">
            <b-row>
              <b-col>
                <h4 v-translate>Quick Search</h4>
                <b-form @submit.prevent="quickSearch">
                  <b-form-row>
                    <b-col md="8">
                      <b-input
                        id="inline-form-input-name"
                        class="mb-2 col-12"
                        :placeholder="searchPlaceholder"
                        v-model="quickSearchTerm"
                      ></b-input>

                      <label class="" for="inline-form-input-name" v-translate>Select Date Range </label><label v-show="dateRangeActive === true">&nbsp;[<a href="#" @click.prevent="resetDateRange">reset range</a>]</label>
                      <date-range-picker
                        v-if="this.locale.daysOfWeek"
                        v-model="dateRange"
                        @update="dateRangeActive = true; quickSearch()"
                        :locale-data="locale"
                        :opens="opens"
                        class="mb-2 w-100"
                        :ranges="ranges"
                        :min-date="minDate"
                      >
                        <div slot="input" slot-scope="picker" style="top: 3px;position:relative">
                          <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" style="vertical-align: middle" />
                          <span style="vertical-align: middle">{{moment(dateRange.startDate).format('L')}} - {{moment(dateRange.endDate).format('L')}}</span>
                        </div>
                      </date-range-picker>
                    </b-col>

                    <b-col>
                      <b-button size="sm" type="submit" variant="primary" v-translate>Search</b-button>
                      <a href="#" class="ml-3" @click.prevent="clearSearch" v-translate>Clear search</a>
                    </b-col>

                  </b-form-row>
                </b-form>
              </b-col>
              <b-col class="text-center align-self-center" md="4">
                <b-button variant="primary" v-b-modal.modalCreateByShipmentId v-translate>
                  Create Shipping by FLEX Shipment ID
                </b-button>
                <b-modal size="md" id="modalCreateByShipmentId" ref="modalCreateByShipmentId" hide-footer @hide="shipmentId = null; shipment = null;">
                  <div slot="modal-title" v-translate>Create Shipping by FLEX Shipment ID</div>
                  <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
                  <form @submit.stop.prevent="getByShipmentId" v-if="!shipment">
                    <label for="ml-shipment-id"><translate>FLEX Shipment ID</translate> <font-awesome-icon icon="question-circle" class="text-info" size="1x" id="tooltip-shipment-id" /></label>
                    <b-form-input type="text" v-model="shipmentId" id="ml-shipment-id" class="mb-3"></b-form-input>
                    <div class="text-center">
                      <b-button size="sm" variant="primary" type="submit" :disabled="!shipmentId" v-translate>
                        Search Order
                      </b-button>
                    </div>
                    <b-tooltip target="tooltip-shipment-id">
                      <translate>You can find the FLEX shipment ID into the FLEX label as shown below</translate>
                      <img src="../assets/img/flex-label.png" style="width: 100%" alt="FLEX">
                    </b-tooltip>
                  </form>
                  <form @submit.stop.prevent="postByShipmentId" v-else>
                    <b-row>
                      <b-col>
                        <strong :class="shipment.status !== 'ready_to_ship' ? 'text-danger' : 'text-success'">{{filterStates[shipment.status]}}</strong>
                      </b-col>
                      <b-col class="text-right">
                        {{moment.utc(shipment.date_created).local().format('L LT')}}
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12">
                        <hr>
                      </b-col>
                      <dl class="col-6 mb-0">
                        <dt v-translate>Order ID</dt>
                        <dd>{{shipment.order_id}}</dd>
                      </dl>
                      <dl class="col-6 mb-0">
                        <dt v-translate>Buyer</dt>
                        <dd>{{shipment.receiver_address.receiver_name}}</dd>
                      </dl>
                      <dl class="col-12 mb-0">
                        <dt v-translate>Destination</dt>
                        <dd>{{shipment.receiver_address.address_line}}, {{shipment.receiver_address.state.name}}, {{shipment.receiver_address.country.name}}</dd>
                      </dl>
                    </b-row>
                    <b-row v-for="(item, index) in shipment.shipping_items" :key="index">
                      <b-col cols="12">
                        <hr>
                      </b-col>
                      <b-col cols="10">
                        - {{item.description}}
                      </b-col>
                      <b-col>
                        {{item.quantity}} u.
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12">
                        <hr>
                      </b-col>
                    </b-row>
                    <h5 v-translate>Origin</h5>
                    <modal-confirmation-body @cancel="closeModalCreateByShipmentId" @success="successModalCreateByShipmentId" />
                  </form>
                </b-modal>
              </b-col>
            </b-row>
          </b-card>

          <b-alert show variant="warning" v-if="!hasCompany">
            <h2 v-translate>Your are almost there!</h2>
            <p v-translate>There is just one step left to be able to make your Mercado Envíos Flex with us:</p>
            <h4><a href="https://moova.io/ofrece-mercado-envios-flex-con-moova/" target="_blank" v-translate>We need to register you as a Company User</a></h4>
            <p v-translate>Then you will be able to start your shipments from this same list like a breeze :)</p>
          </b-alert>
          <b-row>
            <b-col v-show="quickSearchTerm && isSearch">
              <h3 v-translate="{quickSearchTerm: quickSearchTerm}">Search results for: %{quickSearchTerm}</h3>
            </b-col>
            <b-col v-show="!isSearch">
              <h3><translate>Your orders on MercadoLibre</translate> <b-link @click="resetPagination(); fetchSales()"><font-awesome-icon icon="sync-alt" /></b-link></h3>
            </b-col>
          </b-row>
          <b-tabs content-class="mt-3" active-nav-item-class="font-weight-bold mva--listing-tab-active" justified v-model="tabIndex">
            <b-tab>
              <template slot="title">
                <translate>Single orders</translate>
              </template>
              <b-container>
                <b-row style="padding: 0 1.25rem 1rem">
                  <b-col>
                    <b-form-checkbox
                      v-model="selectAllCheckbox"
                      @change="selectAll()"
                    ><translate translate-context="female">Select All/None</translate></b-form-checkbox>
                  </b-col>
                  <b-col class="text-right" v-if="selectedSalesLength > 0">
                    <strong>
                      <translate :translate-n="selectedSalesLength" translate-plural="%{selectedSalesLength} selected">%{selectedSalesLength} selected</translate>
                    </strong>
                  </b-col>
                </b-row>
              </b-container>

              <mercadolibre-list-item ref="meliListItem" :selectable="hasCompany" v-if="tabIndex === 0" v-for="(sale, index) in mySales" @selected="selectListItem" :sale="sale" :key="sale.external_code + index" />

              <transition name="fade">
                <div id="create-shippings-button" v-show="selectedSalesLength !== 0">
                  <b-button type="button" variant="secondary" class="ml-1" size="lg" v-b-modal.modalConfirmation :disabled="selectedSalesLength === 0"><translate :translate-n="selectedSalesLength" translate-plural="Start %{selectedSalesLength} shipments">Start %{selectedSalesLength} shipment</translate></b-button>
                </div>
              </transition>

              <div v-show="!updating && mySales.length === 0">
                <translate>No sales found.</translate>
              </div>
            </b-tab>
            <b-tab>
              <template slot="title">
                <translate>Cart orders</translate>
              </template>
              <b-container>
                <b-row style="padding: 0 1.25rem 1rem">
                  <b-col>
                    <b-form-checkbox
                      v-model="selectAllCheckbox"
                      @change="selectAll()"
                    ><translate translate-context="female">Select All/None</translate></b-form-checkbox>
                  </b-col>
                  <b-col class="text-right" v-if="selectedSalesLength > 0">
                    <strong>
                      <translate :translate-n="selectedSalesLength" translate-plural="%{selectedSalesLength} selected">%{selectedSalesLength} selected</translate>
                    </strong>
                  </b-col>
                </b-row>
              </b-container>
              <mercadolibre-list-item ref="meliListItem" :selectable="hasCompany" v-if="tabIndex === 1" v-for="(sale, index) in mySales" @selected="selectListItem" :sale="sale" :key="sale.external_code + index" />

              <transition name="fade">
                <div id="create-shippings-button" v-show="selectedSalesLength !== 0 && hasStores">
                  <b-button type="button" variant="secondary" class="ml-1" size="lg" v-b-modal.modalConfirmation :disabled="selectedSalesLength === 0"><translate :translate-n="selectedSalesLength" translate-plural="Start %{selectedSalesLength} shipments">Start %{selectedSalesLength} shipment</translate></b-button>
                </div>
              </transition>

              <div v-show="!updating && mySales.length === 0">
                <translate>No sales found.</translate>
              </div>
            </b-tab>
          </b-tabs>
          <p class="text-center mt-3">
            <b-button size="sm" variant="primary" @click="forceRequest = true; bottom = true" :disabled="updating"><b-spinner small v-if="updating"></b-spinner> <translate>Look for more</translate></b-button>
          </p>
        </div>
        <spinner v-if="isLoadingMeli" />

        <b-modal id="modalConfirmation" ref="modalConfirmation" :hide-footer="true">
          <div slot="modal-title" v-translate>New Shippings Origin</div>
          <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
          <modal-confirmation-body @cancel="closeModalConfirmation" @success="successModalConfirmation" />
        </b-modal>

        <b-modal id='IntegrationCreateShippingSuccessMessage' ref='IntegrationCreateShippingSuccessMessage' :hide-footer="true" @hide="winReload">
          <div slot="modal-title" v-translate>Shipments Created</div>
          <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
          <integration-create-shipping-success-message :items='shipmentsCreated' />
        </b-modal>
      </div>
      <div v-else>
        <h1 class="text-center"><translate>Integrate with MercadoLibre</translate>
        <router-link v-translate :to="{ name: 'profile-integrations' }"> here </router-link></h1>
      </div>
    </div>
    <div v-else>
      <company-credit-overlay />
    </div>
  </div>

</template>
<script>
import { mapGetters } from 'vuex'
import MercadolibreListItem from '@/components/MercadolibreListItem'
import IntegrationCreateShippingSuccessMessage from '@/components/IntegrationCreateShippingSuccessMessage'
import ModalConfirmationBody from '@/components/ModalConfirmationBody'
import Paginator from '@/components/Paginator'
import { FETCH_SALES, RESET_SHIPPINGS, FETCH_PROFILE } from '@/store/actions.type'
import Spinner from '@/components/Spinner'
import AddressMixin from '@/mixins/address.mixin.js'
import ShippingPreview from '@/components/ShippingPreview'
import DateRangePicker from 'vue2-daterange-picker'
import ModalNeedStores from '@/components/ModalNeedStores'
import CompanyCreditOverlay from '@/components/CompanyCreditOverlay'
import WidgetCutTime from '@/components/WidgetCutTime'

export default {
  name: 'MercadolibreList',
  components: {
    MercadolibreListItem,
    ModalConfirmationBody,
    Paginator,
    IntegrationCreateShippingSuccessMessage,
    Spinner,
    ShippingPreview,
    DateRangePicker,
    ModalNeedStores,
    CompanyCreditOverlay,
    WidgetCutTime
  },
  props: {
    type: {
      type: String,
      required: false,
      default: 'all'
    },
    itemsPerPage: {
      type: Number,
      required: false,
      default: 5
    }
  },
  data() {
    return {
      bottom: false,
      forceRequest: false,
      shipmentsCreated: [],
      selectedSales: [],
      formatted_addressselectedSales: [],
      mySales: [],
      backupSales: [],
      nextPage: 1,
      isSearchingByFilters: false,
      searchFilters: {},
      quickSearchTerm: '',
      quickSearchStates: '',
      filterStates: {
        delivered: this.$gettext('Delivered'),
        shipped: this.$gettext('In transit'),
        to_be_agreed: this.$gettext('To be agreed'),
        ready_to_ship: this.$gettext('Ready to ship'),
        cancelled: this.$gettext('Cancelled'),
        not_delivered: this.$gettext('Not delivered'),
        pending: this.$gettext('Pending'),
        handling: this.$gettext('Handling'),
        not_verified: this.$gettext('Not verified'),
        closed: this.$gettext('Closed'),
        error: this.$gettext('Error'),
        active: this.$gettext('Active'),
        not_specified: this.$gettext('Not specified'),
        stale_ready_to_ship: this.$gettext('Ready to ship (staled)'),
        stale_shipped: this.$gettext('Shipped (staled)')
      },
      isSearch: false,
      newSearch: true,
      searchPlaceholder: this.$gettext('Search by Order ID, Item ID or Buyer username, name or email'),
      tabIndex: this.tabIndex || 0,
      hadNew: false,
      refreshInterval: null,
      selectAllCheckbox: false,
      dateRange: {
        startDate: this.moment().subtract(6, 'day').toDate(),
        endDate: this.moment().subtract(0, 'day').toDate()
      },
      dateRangeActive: false,
      opens: 'right',
      locale: {},
      ranges: {},
      minDate: this.moment().subtract(30, 'day').startOf('day').toDate(),
      datepickerLocalized: false,
      restartMlIntegration: false,
      meliZones: [],
      originalZones: [],
      updateZones: [],
      shipmentId: null,
      shipment: null,
      meliAutomatic: {
        reference: this.$store.getters.profile.platform_user_authorizations.find(x => x.platform.slug === 'meli').from_store_id ? this.$store.getters.profile.company.stores.find(y => y.id === this.$store.getters.profile.platform_user_authorizations.find(x => x.platform.slug === 'meli').from_store_id).reference : (this.$store.getters.profile.platform_user_authorizations.find(x => x.platform.slug === 'meli').from_place_id ? this.$store.getters.profile.company.stores.find(y => y.place_id === this.$store.getters.profile.platform_user_authorizations.find(x => x.platform.slug === 'meli').from_place_id).reference : null),
        automatic: Boolean(this.$store.getters.profile.platform_user_authorizations.find(x => x.platform.slug === 'meli').automatic) || false,
        from_place_id: this.$store.getters.profile.platform_user_authorizations.find(x => x.platform.slug === 'meli').from_place_id || null,
        from_store_id: this.$store.getters.profile.platform_user_authorizations.find(x => x.platform.slug === 'meli').from_store_id || null
      },
      stores: this.$store.getters.profile.company.stores
    }
  },
  computed: {
    listConfig() {
      const filters = {
        limit: 20,
        totalSales: 0,
        params: {
          page: this.nextPage || 1
          // status: 'ready_to_ship,stale_ready_to_ship'
        }
      }
      if (this.tabIndex === 1) {
        filters.params.cart = true
      }

      if (this.quickSearchTerm) {
        this.isSearch = true
        this.isSearchingByFilters = true
        filters.params = {
          query: this.quickSearchTerm,
          page: this.nextPage || 1
        }
      } else {
        this.isSearch = false
      }

      return {
        filters,
        updating: this.updating
      }
    },
    pages() {
      if (this.isLoadingMeli || this.shippingsCount <= this.itemsPerPage) {
        return []
      }
      return [...Array(Math.ceil(this.shippingsCount / this.itemsPerPage)).keys()].map(e => e + 1)
    },
    totalPages() {
      return Math.ceil(this.shippingsCount / this.itemsPerPage)
    },
    alreadyIntegrated() {
      if (this.$store.getters.profile.platform_user_authorizations && this.$store.getters.profile.platform_user_authorizations.length > 0) {
        return this.$store.getters.profile.platform_user_authorizations.findIndex(x => x.platform.slug === 'meli') !== -1 || false
      } else {
        return false
      }
    },
    selectedSalesLength() {
      return this.selectedSales.length
    },
    hasCompany() {
      return this.$store.getters.profile.company_id !== null
    },
    hasStores() {
      return this.$store.getters.profile && this.$store.getters.profile.company && this.$store.getters.profile.company.stores.length > 0
    },
    canEnableZones() {
      return this.meliZones.filter(x => x.area && x.selected).length < this.meliZones.filter(x => x.area && x.selected).length + this.meliZones.filter(x => x.area && !x.selected).length
    },
    noFlexData() {
      return !this.hasFlex
    },
    ...mapGetters([
      'isLoadingMeli',
      'totalSalesPages',
      'totalSales',
      'currentSalesPage',
      'sales',
      'updating',
      'hasFlex'
    ])
  },
  watch: {
    bottom(bottom) {
      if ((bottom && this.mySales.length && this.mySales.length < this.totalSales) || this.forceRequest) {
        if (this.isSearch) {
          this.listConfig.filters.params.query = this.quickSearchTerm
        }
        this.fetchSales()
      }
      this.bottom = false
      this.forceRequest = false
    },
    sales(newSales) {
      if (this.isSearchingByFilters) {
        this.isSearchingByFilters = false
      }
      this.mySales = this.mySales.concat(newSales)
      this.hadNew = newSales.length > 0 || false
    },
    tabIndex(val) {
      if (val === 1) {
        this.listConfig.filters.params.cart = true
      } else {
        delete (this.listConfig.filters.params.cart)
      }
      this.selectAllCheckbox = false
      this.selectedSales = []
      this.mySales = []
      this.resetPagination()
      if (this.isSearch) {
        this.quickSearch()
      } else {
        this.fetchSales(this.listConfig)
      }
    },
    'meliAutomatic.reference': {
      handler(val) {
        if (val === null) {
          this.meliAutomatic.automatic = false
        } else {
          this.meliAutomatic.from_store_id = this.stores.find(x => x.reference === val).id
          this.meliAutomatic.from_place_id = this.stores.find(x => x.reference === val).place_id
          this.patchPlatformUserAuthorization()
        }
      },
      deep: true
    },
    'meliAutomatic.automatic': {
      handler(val) {
        this.patchPlatformUserAuthorization()
      },
      deep: true
    }
  },
  created() {
    // window.addEventListener('scroll', () => {
    //   this.bottom = this.bottomVisible()
    // })
  },
  mounted() {
    this.init()
    this.refreshInterval = setInterval(function () {
      this.init()
    }.bind(this), 1800000)
  },
  beforeDestroy() {
    this.resetShippings()
    clearInterval(this.refreshInterval)
  },
  mixins: [AddressMixin],
  methods: {
    selectAll() {
      for (let i = 0; i < this.$refs.meliListItem.length; i++) {
        if (!this.selectAllCheckbox) {
          this.$refs.meliListItem[i].doCheck()
        } else {
          this.$refs.meliListItem[i].doUncheck()
        }
      }
    },
    init() {
      this.selectedSales = []
      this.initDatePicker()
      this.resetPagination()
      this.fetchSales()
      this.checkCutHour()
    },
    initDatePicker() {
      this.locale = {
        direction: 'ltr', //  direction of text
        format: 'dd/mm/yyyy', //  fomart of the dates displayed
        separator: ' - ', //  separator between the two ranges
        applyLabel: this.$gettext('Apply'),
        cancelLabel: this.$gettext('Cancel'),
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: this.moment.weekdaysMin(), // days, //  array of days - see moment documenations for details
        monthNames: this.moment.monthsShort(), //  array of month names - see moment documenations for details
        firstDay: this.moment().day(0) === this.moment().local().weekday(0) ? 0 : 1, //  ISO first day of week - see moment documenations for details
        showWeekNumbers: false //  show week numbers on each row of the calendar
      }
      this.ranges = { //  default value for ranges object (if you set this to false ranges will no be rendered)
        [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
        [this.$gettext('Yesterday')]: [this.moment().subtract(1, 'days').toDate(), this.moment().subtract(1, 'days').toDate()],
        [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'days').toDate(), this.moment().toDate()],
        [this.$gettext('Last 30 days')]: [this.moment().subtract(29, 'days').toDate(), this.moment().toDate()]
      }
      this.datepickerLocalized = true
    },
    resetDateRange() {
      this.dateRange = {
        startDate: this.moment().subtract(6, 'day').startOf('day').toDate(),
        endDate: this.moment().subtract(0, 'day').endOf('day').toDate()
      }
      this.dateRangeActive = false
      this.quickSearch()
    },
    quickSearch() {
      if (this.quickSearchTerm) {
        this.isSearch = true
        this.isSearchingByFilters = true
        this.searchFilters = {
          query: this.quickSearchTerm,
          page: 1
        }
        if (this.tabIndex === 1) {
          this.searchFilters.cart = true
        }
        this.mySales = []
      } else {
        this.isSearch = false
        this.searchFilters = { page: 1 }
      }

      this.listConfig.filters.params = this.searchFilters
      this.mySales = []
      this.resetPagination()
      this.fetchSales(this.listConfig)
    },
    clearSearch() {
      if (!this.mySales.length && this.backupSales.length) {
        this.mySales = this.backupSales
      }
      this.advancedSearchTerm = ''
      this.advancedSearchStatus = []
      this.advancedSearchFilters = []
      this.backupSales = []
      this.quickSearchTerm = ''
      delete (this.listConfig.filters.params.query)
      this.isSearch = false
      this.searchFilters = {}
      this.mySales = []
      this.resetPagination()
      this.fetchSales()
      this.$router.push({ name: this.$route.name })
    },
    resetShippings() {
      this.$store.dispatch(RESET_SHIPPINGS, this.listConfig)
    },
    bottomVisible() {
      const scrollY = window.scrollY
      const visible = document.documentElement.clientHeight
      const pageHeight = document.documentElement.scrollHeight
      const bottomOfPage = visible + scrollY + 0 >= pageHeight
      return bottomOfPage || pageHeight < visible
    },
    fetchSales(params) {
      this.listConfig.filters.params.date_from = this.moment(this.dateRange.startDate).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
      this.listConfig.filters.params.date_to = this.moment(this.dateRange.endDate).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
      const config = params !== undefined ? params : this.listConfig
      this.$store.dispatch(FETCH_SALES, config)
        .then(() => {
          this.nextPage = this.currentSalesPage
          this.listConfig.filters.params.page = this.hadNew === true ? this.nextPage++ : this.nextPage
        })
    },
    resetPagination() {
      this.mySales = []
      this.listConfig.offset = 0
      this.nextPage = 1
      this.listConfig.filters.params.page = 1
    },
    closeModalConfirmation() {
      this.$refs.modalConfirmation.hide()
    },
    async successModalConfirmation(item) {
      try {
        const promiseStartShiments = []
        this.shipmentsCreated = []
        const meliIds = {}
        for (const sale of this.selectedSales) {
          const id = sale.external_code
          if (!meliIds[id]) {
            const result = this.getShippingObj({ ...sale, originAddress: item.originAddress })
            promiseStartShiments.push(this.startShipment(result))
          }
          meliIds[id] = true
        }

        this.shipmentsCreated = await Promise.all(promiseStartShiments)
        this.$refs.modalConfirmation.hide()
        this.$refs.IntegrationCreateShippingSuccessMessage.show()
        this.selectedSales = []
      } catch (error) {
        console.log('try catch')
        console.log(error)
        this.$refs.modalConfirmation.hide()
        this.$refs.IntegrationCreateShippingSuccessMessage.show()
        this.selectedSales = []
      }
    },
    async startShipment(payload) {
      try {
        const shipment = await this.$http.post(`${this.$appConfig.api.baseUrl}users/platforms/meli/shipping`, payload)
        return { id: payload.shipment_id, status: this.$gettext('Success'), link: shipment.body.id }
      } catch (e) {
        return { id: payload.shipment_id, status: this.$gettext('Failed'), link: null, err: 'Status: ' + e.status + ' - ' + e.body.message, _rowVariant: 'danger' }
      }
    },
    selectListItem(item) {
      if (item.checked) {
        this.selectedSales.push(item.data)
      } else {
        this.selectedSales.splice(this.selectedSales.indexOf(item.data), 1)
      }
    },
    getShippingObj(data) {
      const shippingObj = {
        from: {
          floor: data.originAddress.from_extra,
          apartment: null,
          country: this.$store.getters.profile.company.country_iso_code,
          instructions: data.originAddress.from_meta,
          contact: {
            first_name: data.originAddress.from_contact,
            last_name: null,
            email: data.originAddress.from_email,
            phone: data.originAddress.from_phone
          },
          message: ''
        },
        flow: this.$store.getters.profile.company.settings.find(x => x.name === 'via_warehouse') && this.$store.getters.profile.company.settings.find(x => x.name === 'via_warehouse').pivot && this.$store.getters.profile.company.settings.find(x => x.name === 'via_warehouse').pivot.value === '1' ? 'warehouse' : 'semi-automatic',
        shipment_id: data.external_code + ''
      }
      if (typeof data.originAddress.from_place_id !== 'string') {
        shippingObj.from.place_id = data.originAddress.from_place_id
      } else {
        shippingObj.from.google_place_id = data.originAddress.from_place_id
      }
      return shippingObj
    },
    winReload() {
      this.resetPagination()
      this.fetchSales()
    },
    checkCutHour() {
      let meliZones
      let payload

      if (!this.$frontConfig.meliApiVersion) {
        payload = {
          settings: {
            zones: {
              0: 'id',
              1: 'label',
              3: 'selected',
              price: {
                0: 'cents',
                1: 'fraction'
              }
            },
            cutoff: {
              selected: [
                'week',
                'saturday',
                'sunday'
              ]
            },
            2: 'working_days'
          }
        }
      } else if (this.$frontConfig.meliApiVersion === 'flex') {
        payload = {
          settings: {
            0: 'working_days',
            zones: {
              0: 'id',
              1: 'label',
              2: 'selected',
              price: {
                0: 'cents',
                1: 'fraction'
              }
            },
            delivery_ranges: {
              week: {
                0: 'calculated_cutoff'
              },
              saturday: {
                0: 'calculated_cutoff'
              },
              sunday: {
                0: 'calculated_cutoff'
              }
            },
            subscription: {
              0: 'site_id',
              1: 'user_id',
              2: 'service_id',
              3: 'creation_date',
              status: {
                0: 'id'
              }
            }
          }
        }
      }
      this.$http.post(this.$appConfig.api.baseUrl + 'platforms/meli/shippings/settings' + (!this.$frontConfig.meliApiVersion ? '' : '?meli_version=' + this.$frontConfig.meliApiVersion), payload)
        .then(response => {
          if (!response.body.error) {
            this.$store.dispatch('setHasFlex', true)
            meliZones = response.body.configuration.zones.availables.zones

            if (!this.checkCutoffTimes(response.body.configuration)) {
              this.$http.patch(this.$appConfig.api.baseUrl + 'platforms/meli/sync-cut-off')
                .then(response => {
                  this.$store.dispatch(FETCH_PROFILE)
                    .then(response => {
                      const payload = { profile: response }
                      this.$store.commit('setProfile', payload)
                    })
                  clearInterval(this.refreshInterval)
                  this.refreshInterval = setInterval(function () {
                    this.init()
                  }.bind(this), 1800000)
                  this.init()
                })
            }
            this.$http.get(this.$appConfig.api.baseUrl + 'platforms/meli/shippings/areas')
              .then(response => {
                this.meliZones = meliZones.map((x, i) => {
                  return { ...x, ...response.body.find(y => y.id === x.id) }
                })

                this.originalZones = this.meliZones.filter(x => x.area && x.selected).map(x => x.id)
                this.updateZones = [...new Set(this.originalZones)]
              })
          }
        }, error => {
          if (error.status === 428) {
            this.$root.$children[0].$refs.simplert.justCloseSimplert()
          }
          if (error.status === 401) {
            this.restartMlIntegration = true
            this.$root.$children[0].$refs.simplert.justCloseSimplert()
          }
        })
    },
    checkCutoffTimes(configuration) {
      let inSync = true

      if (configuration.cutoff) { // ML API v2
        for (const [key, value] of Object.entries(configuration.cutoff.selected)) {
          configuration.cutoff.selected[key] = configuration.working_days.indexOf(key) !== -1 ? value : null
          if (
            (configuration.cutoff.selected[key] !== null && configuration.cutoff.selected[key] + ':15:00' !== this.$store.getters.profile.company['cut_time_' + key]) ||
            (configuration.cutoff.selected[key] === null && this.$store.getters.profile.company['cut_time_' + key])
          ) {
            inSync = false
          }
        }
      } else { // ML API v3
        configuration = { ...configuration, ...configuration.delivery_ranges.availables }
        for (const [key, value] of Object.entries(configuration.delivery_ranges)) {
          configuration.delivery_ranges[key] = configuration.working_days.indexOf(key) !== -1 ? value[0].calculated_cutoff : null
          if (
            (configuration.delivery_ranges[key] !== null && configuration.delivery_ranges[key] + ':15:00' !== this.$store.getters.profile.company['cut_time_' + key]) ||
            (configuration.delivery_ranges[key] === null && this.$store.getters.profile.company['cut_time_' + key])
          ) {
            inSync = false
          }
        }
      }

      return inSync
    },
    doUpdateZones() {
      const toAdd = this.updateZones.filter(x => !this.originalZones.includes(x))
      const toDelete = this.originalZones.filter(x => !this.updateZones.includes(x))

      if (toAdd.length > 0 && toDelete.length > 0) {
        this.$http.post(this.$appConfig.api.baseUrl + 'platforms/meli/shippings/areas' + (!this.$frontConfig.meliApiVersion ? '' : '?meli_version=' + this.$frontConfig.meliApiVersion), { meli_areas: toAdd })
          .then(response => {
            setTimeout(function () {
              this.$http.delete(this.$appConfig.api.baseUrl + 'platforms/meli/shippings/areas' + (!this.$frontConfig.meliApiVersion ? '' : '?meli_version=' + this.$frontConfig.meliApiVersion), { body: { meli_areas: toDelete } })
                .then(response => {
                  this.checkCutHour()
                  this.$refs.modalReviewMeliZones.hide()
                })
            }.bind(this), 500)
          })
      } else if (toDelete.length > 0 && toAdd.length === 0) {
        this.$http.delete(this.$appConfig.api.baseUrl + 'platforms/meli/shippings/areas' + (!this.$frontConfig.meliApiVersion ? '' : '?meli_version=' + this.$frontConfig.meliApiVersion), { body: { meli_areas: toDelete } })
          .then(response => {
            this.checkCutHour()
            this.$refs.modalReviewMeliZones.hide()
          })
      } else {
        this.$http.post(this.$appConfig.api.baseUrl + 'platforms/meli/shippings/areas' + (!this.$frontConfig.meliApiVersion ? '' : '?meli_version=' + this.$frontConfig.meliApiVersion), { meli_areas: toAdd })
          .then(response => {
            this.checkCutHour()
            this.$refs.modalReviewMeliZones.hide()
          })
      }
    },
    patchPlatformUserAuthorization() {
      if (!this.meliAutomatic.from_store_id) {
        this.meliAutomatic.from_store_id = this.stores.find(x => x.reference === this.meliAutomatic.reference).id
      }
      this.$http.patch(this.$appConfig.api.baseUrl + 'users/' + this.$store.getters.profile.id + '/platform-user-authorizations/' + this.$store.getters.profile.platform_user_authorizations.find(x => x.platform.slug === 'meli').id, this.meliAutomatic)
        .then(response => {
          this.$store.dispatch(FETCH_PROFILE)
            .then(response => {
              const payload = { profile: response }
              this.$store.commit('setProfile', payload)
            })
        })
    },
    getByShipmentId() {
      this.$http.get(this.$appConfig.api.baseUrl + 'platforms/meli/external/' + this.shipmentId)
        .then(response => {
          this.shipment = response.body
        })
    },
    successModalCreateByShipmentId(e) {
      const payload = {
        shipment_id: this.shipment.id + '',
        from: {
          contact: {
            first_name: e.originAddress.from_contact || '',
            last_name: ' ',
            email: e.originAddress.from_email || '',
            phone: e.originAddress.from_phone || ''
          },
          place_id: e.originAddress.from_place_id,
          instructions: e.originAddress.from_meta || null
        }
      }
      this.$http.post(this.$appConfig.api.baseUrl + 'users/platforms/meli/shipping', payload)
        .then(response => {
          this.resetPagination()
          this.fetchSales()
          this.closeModalCreateByShipmentId()
        }, error => {
          console.log(error)
          if (error.status === 409) {
            this.$root.$children[0].$refs.simplert.justCloseSimplert()
            const obj = {
              title: 'ERROR',
              message: this.$gettext('The shipping has been created before'),
              type: 'error',
              customCloseBtnText: this.$gettext('Close')
            }
            this.$root.$children[0].$refs.simplert.openSimplert(obj)
            this.closeModalCreateByShipmentId()
          }
        })
    },
    closeModalCreateByShipmentId() {
      this.$refs.modalCreateByShipmentId.hide()
    }
  }
}
</script>

<style lang="scss">
#mercadolibre-list {
  padding-bottom: 50px;
  .nav-tabs .nav-link {
    border: none !important;
    &.mva--listing-tab-active {
      border: none !important;
      border-bottom: 5px solid #4fa0ff !important;
    }
  }
}
#create-shippings-button {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  border-top: 1px solid #ddd;
  text-align: center;
  background: #fff;
  padding: 30px;
  z-index: 1;
}
.fade-enter,
.fade-leave-to { opacity: 0 }

.fade-leave,
.fade-enter-to { opacity: 1 }

.fade-enter-active,
.fade-leave-active { transition: opacity 300ms ease }

.text-muted {
  color: #ccc !important
}
</style>
